import { render, staticRenderFns } from "./Experiencia.vue?vue&type=template&id=a222a74a&scoped=true&lang=pug&"
import script from "./Experiencia.vue?vue&type=script&lang=js&"
export * from "./Experiencia.vue?vue&type=script&lang=js&"
import style0 from "./Experiencia.styl?vue&type=style&index=0&id=a222a74a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a222a74a",
  null
  
)

export default component.exports